import { getTransferActivityTableHeaderRules } from "./Utils";
import { PERMISSIONS } from "./Pemissions";
import theme from "src/themes";

/* eslint-disable object-property-newline */
export const DOC_STATUS = {
  APPROVED: "Approved",
  PENDING: "Pending",
  ADJUSTED: "Adjusted",
  REJECTED: "Rejected",
  RECONCILED: "Reconciled",
  RECEIVED: "Received"
};

export const RECEIVING_TYPE_ID = {
  MANUAL_TRANSFER: "MANUAL TRANSFER",
  TRANSFER: "TRANSFER",
  DSD: "DSD",
  CREDIT: "CREDIT",
  OVER_SHORT: "OVER/SHORT",
  PINK: "PINK",
  THROWAWAY: "THROWAWAY",
  YELLOW: "YELLOW",
  RED: "RED",
  FREIGHT_CLAIM: "FREIGHT CLAIM",
  INVENTORY_ADJUSTMENT: "INVENTORY ADJUSTMENT",
  PHYSICAL_INVENTORY: "PHYSICAL INVENTORY",
  PRICE_CHANGE: "PRICE CHANGE",
  MARKDOWN: "MARKDOWN",
  PENDING_INVENTORY_CREDITS: "PENDING INVENTORY CREDITS",
  CORRECTIVE_BILLING: "CORRECTIVE BILLING"
};

export const dateRangePlaceHolder = "mm/dd/yy - mm/dd/yy";

export const userRoles = {
  IO: "Independent Operator",
  LU: "Logistics User",
  IA: "Inventory Accounting User",
  UO: "Universal Operator",
  SU: "Support",
  OA: "Operational Admin"
};

export const types = [
  { name: "Direct PO", id: "1" },
  { name: "Warehouse Transfer", id: "2" },
  { name: "Manual Transfer", id: "3" },
  { name: "DSD", id: "4" },
  { name: "DSD Credit", id: "5" },
  { name: "Over/Short", id: "6" },
  { name: "Flexible Ordering", id: "7" },
  { name: "Pink", id: "8" },
  { name: "Throwaway", id: "9" },
  { name: "Yellows/Reds", id: "10" },
  { name: "Freight Claim", id: "11" },
  { name: "Inventory Adjustment", id: "12" }
];

export const type = [
  { name: "Transfer", id: "Transfer" },
  { name: "DSD", id: "DSD" },
  { name: "DSD Credit", id: "Credit" },
  { name: "Pink", id: "Pink" },
  { name: "Freight Claim", id: "Freight Claim" },
  { name: "Over/Short", id: "Over/Short" },
  { name: "Price Change", id: "Price Change" },
  { name: "Markdown", id: "Markdown" },
  { name: "Throwaway", id: "Throwaway" },
  { name: "Physical Inventory", id: "Physical Inventory" },
  { name: "Pending Inventory Credits", id: "Inventory Adjustment" },
  { name: "Manual Transfer", id: "Manual Transfer" },
  { name: "Red", id: "Red" },
  { name: "Yellow", id: "Yellow" }
];

export const status = [
  { name: "In-Transit", id: "1" },
  { name: "On Order", id: "2" },
  { name: "Draft", id: "3" },
  { name: "Received", id: "4" },
  { name: "Approved", id: "5" },
  { name: "Pending", id: "6" },
  { name: "Adjusted", id: "7" },
  { name: "Rejected", id: "8" }
];

export const statuses = [
  { name: "Stock In Transit", id: "Stock in Transit" },
  { name: "Open", id: "Open" },
  { name: "On Order", id: "On Order" },
  { name: "Draft", id: "Draft" },
  { name: "Finalized", id: "Finalized" },
  { name: "Received", id: "Received" },
  { name: "Approved", id: "Approved" },
  { name: "Pending", id: "Pending" },
  { name: "Adjusted", id: "Adjusted" },
  { name: "Rejected", id: "Rejected" },
  { name: "Submitted", id: "Submitted" },
  { name: DOC_STATUS.RECONCILED, id: DOC_STATUS.RECONCILED }
];

export const alerts = [
  { name: "Alerts", id: "1" },
  { name: "No Alerts", id: "2" }
];

export const alert = [
  { name: "Alerts", id: "Alerts" },
  { name: "No Alerts", id: "No Alerts" }
];

export const vendors = [
  { id: "1000000014", name: "ABC Food" },
  { id: "1000000062", name: "BASIC AMERICAN FOODS - MODERN TABLE" },
  { id: "1000000060", name: "CHRISTOPHER RANCH LLC" },
  { id: "1000000061", name: "CHU YING MA" },
  { id: "1000000112", name: "Kraft Heinz Foods Company" }
];

export const warehouses = [
  { id: "0090", name: "Sacramento Wine" },
  { id: "0093", name: "Modesto" },
  { id: "0094", name: "Tacoma" },
  { id: "0095", name: "Portland" },
  { id: "0096", name: "Lancaster" },
  { id: "0097", name: "Sacramento" },
  { id: "0098", name: "Leola" },
  { id: "0952", name: "Vancouver" },
  { id: "0993", name: "Ontario" },
  { id: "0995", name: "Vancouver Wine" },
  { id: "0996", name: "New Holland Deli Express" },
  { id: "0997", name: "Los Angeles" }
];

export const API_STATUS = {
  PENDING: "pending",
  ERROR: "error",
  IDLE: "idle",
  FULFILLED: "fulfilled",
  ERROR_CANCELED: "ERR_CANCELED"
};
export type API_STATUS_TYPE = "pending" | "idle" | "error" | "fulfilled";

export const MAX_PO_ATTACHMENT_FILE_SIZE = 30720; // 30MB
export const DUMMY_DOC_ID = "123";
export const ROW_HIGHLIGHTED_COLOR = theme.palette.primary.contrastText;

export const map: { [key: string]: any } = {
  "price-itemName": {
    id: "itemWithoutLink",
    sortBy: "itemId",
    headerStyleOverrides: { width: "80px", px: "10px" },
    dataCellStyleOverrides: { width: "80px", px: "10px" },
    isSortable: true
  },
  "price-item": {
    id: "item",
    dataCellStyleOverrides: { width: "180px", px: "10px" },
    isSortable: true,
    sortBy: "item",
    headerStyleOverrides: { px: "10px", width: "180px" }
  },
  "price-pack": {
    headerStyleOverrides: { px: "12px" },
    id: "pack",
    align: "right",
    dataCellStyleOverrides: { width: "60px", px: "12px" }
  },
  "price-size": {
    id: "size",
    headerStyleOverrides: { px: "12px" },
    align: "left",
    dataCellStyleOverrides: { width: "80px", px: "12px" }
  },
  "price-upc": {
    id: "upcLink",
    isSeparated: true,
    isSortable: true,
    sortBy: "upc",
    align: "right",
    headerStyleOverrides: { px: "12px", width: "140px" },
    dataCellStyleOverrides: { px: "12px", width: "140px" }
  },
  "price-posDescription": {
    isSeparated: true,
    sortBy: "posDescription",
    isSortable: true,
    id: "posDescription",
    align: "left",
    headerStyleOverrides: { px: "12px", width: "150px" },
    dataCellStyleOverrides: { px: "12px", width: "150px" }
  },
  "price-storeRetail": {
    id: "storeRetail",
    isSortable: true,
    sortBy: "storeRetail",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: { px: "12px", width: "80px" },
    dataCellStyleOverrides: { width: "80px", px: "12px" }
  },
  "price-goiRetail": {
    id: "goiRetail",
    isSortable: true,
    sortBy: "goiRetail",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: { px: "12px", width: "80px" },
    dataCellStyleOverrides: { width: "80px", px: "12px" }
  },
  "price-exceptionType": {
    id: "exceptionType",
    isSortable: true,
    sortBy: "exceptionType",
    isSeparated: true,
    headerStyleOverrides: { px: "12px", width: "80px" },
    dataCellStyleOverrides: { width: "80px", px: "12px" }
  },
  "price-lastSoldDate": {
    id: "lastSoldDate",
    isSortable: true,
    dataCellStyleOverrides: { px: "12px" },
    sortBy: "lastSoldDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      width: "7%",
      whiteSpace: "initial",
      "& h6": { width: "70px", textAlign: "right" },
      px: "12px"
    }
  },
  "price-goiPriceChangeDate": {
    headerStyleOverrides: {
      width: "7%",
      whiteSpace: "initial",
      "& h6": { width: "80px", textAlign: "right" },
      px: "12px"
    },
    id: "goiPriceChangeDate",
    isSortable: true,
    align: "right",
    dataCellStyleOverrides: { px: "12px" },
    isSeparated: true,
    sortBy: "goiPriceChangeDate"
  },
  "price-lastShippedRetail": {
    id: "lastShippedRetail",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      width: "6%",
      px: "12px",
      whiteSpace: "initial",
      "& h6": { width: "70px", textAlign: "right" }
    },
    isSortable: true,
    sortBy: "lastShippedRetail",
    dataCellStyleOverrides: { px: "12px" }
  },
  "price-lastShippedDate": {
    id: "lastShippedDate",
    headerStyleOverrides: {
      "& h6": { width: "80px", textAlign: "right" },
      px: "12px",
      width: "7%",
      whiteSpace: "initial"
    },
    isSeparated: true,
    isSortable: true,
    dataCellStyleOverrides: { px: "12px" },
    align: "right"
  },
  "dept-itemName": {
    id: "itemWithoutLink",
    align: "right",
    sortBy: "itemId",
    headerStyleOverrides: { px: "12px" },
    dataCellStyleOverrides: { px: "12px" },
    isSortable: true
  },
  "dept-item": {
    sortBy: "item",
    id: "item",
    isSortable: true,
    headerStyleOverrides: { px: "12px", width: "230px" },
    dataCellStyleOverrides: { width: "230px", px: "12px" }
  },
  "dept-pack": {
    id: "pack",
    dataCellStyleOverrides: { width: "70px", px: "12px" },
    align: "right",
    headerStyleOverrides: { px: "12px" }
  },
  "dept-size": {
    id: "size",
    dataCellStyleOverrides: { width: "90px", px: "12px" },
    align: "left",
    headerStyleOverrides: { px: "12px" }
  },
  "dept-upc": {
    id: "upcLink",
    headerStyleOverrides: { px: "12px", width: "140px" },
    dataCellStyleOverrides: { px: "12px", width: "140px" },
    isSortable: true,
    sortBy: "upc",
    align: "right",
    isSeparated: true
  },
  "dept-posDescription": {
    id: "posDescription",
    headerStyleOverrides: { px: "12px", width: "150px" },
    dataCellStyleOverrides: { px: "12px", width: "150px" },
    align: "left",
    sortBy: "posDescription",
    isSeparated: true,
    isSortable: true
  },
  "dept-goiDescription": {
    id: "goiDescription",
    align: "left",
    sortBy: "goiDescription",
    isSeparated: true,
    isSortable: true,
    headerStyleOverrides: { px: "12px", width: "150px" },
    dataCellStyleOverrides: { px: "12px", width: "150px" }
  },
  "dept-storeDept": {
    id: "storeDept",
    isSortable: true,
    sortBy: "storeDept",
    align: "left",
    isSeparated: true,
    headerStyleOverrides: { px: "12px" },
    dataCellStyleOverrides: { px: "12px", fontSize: "14px" }
  },
  "dept-goiDept": {
    id: "goiDept",
    isSortable: true,
    sortBy: "goiDept",
    align: "left",
    isSeparated: true,
    headerStyleOverrides: { px: "12px" },
    dataCellStyleOverrides: { px: "12px", fontSize: "14px" }
  },
  "dept-lastSoldDate": {
    id: "lastSoldDate",
    isSortable: true,
    dataCellStyleOverrides: { px: "12px" },
    sortBy: "lastSoldDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      whiteSpace: "initial",
      "& h6": { width: "90px" },
      px: "12px"
    }
  },
  "dept-storeDeptChangeDate": {
    id: "storeDeptChangeDate",
    isSortable: true,
    sortBy: "storeDeptChangeDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      whiteSpace: "initial",
      "& h6": { width: "90px" },
      px: "12px"
    },
    dataCellStyleOverrides: { px: "12px" }
  },
  "dept-goiDeptChangeDate": {
    id: "goiDeptChangeDate",
    isSortable: true,
    sortBy: "goiDeptChangeDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      whiteSpace: "initial",
      "& h6": { width: "90px" },
      px: "12px"
    },
    dataCellStyleOverrides: { px: "12px" }
  },
  "dept-username": {
    id: "username",
    align: "left",
    isSortable: true,
    sortBy: "userName",
    headerStyleOverrides: { width: "100px" },
    dataCellStyleOverrides: { px: "12px" }
  },
  "nosale-itemName": {
    id: "itemWithoutLink",
    sortBy: "itemId",
    isSortable: true,
    headerStyleOverrides: { minWidth: "90.5px" }
  },
  "products-itemName": {
    id: "itemWithoutLink",
    sortBy: "itemId",
    isSortable: true,
    headerStyleOverrides: { width: "6%", textAlign: "left" }
  },
  "dsd-itemName": {
    id: "itemName",
    isSortable: true,
    headerStyleOverrides: { minWidth: "90.5px" }
  },
  "nosale-item": {
    id: "item",
    isSortable: true,
    headerStyleOverrides: { minWidth: "205.64px" }
  },
  "products-item": {
    id: "item",
    isSortable: true,
    headerStyleOverrides: { width: "14%" }
  },
  "dsd-item": {
    id: "item",
    isSortable: true,
    headerStyleOverrides: { minWidth: "205.64px" }
  },
  "nosale-pack": {
    id: "pack",
    align: "center",
    headerStyleOverrides: { minWidth: "70px" }
  },
  "products-pack": {
    id: "pack",
    align: "center",
    isSortable: true,
    headerStyleOverrides: { width: "4%" }
  },
  "dsd-pack": {
    id: "pack",
    align: "center",
    headerStyleOverrides: { minWidth: "70px" }
  },
  "nosale-value": {
    id: "value",
    align: "center",
    isSeparated: true,
    headerStyleOverrides: { minWidth: "129px" }
  },
  "products-value": {
    id: "value",
    align: "center",
    isSeparated: true,
    headerStyleOverrides: { width: "7%" },
    isSortable: true
  },
  "nosale-size": {
    id: "size",
    align: "left",
    headerStyleOverrides: { minWidth: "72px" }
  },
  "products-size": {
    id: "size",
    align: "left",
    isSortable: true,
    headerStyleOverrides: { width: "4%" }
  },
  "dsd-size": {
    id: "size",
    align: "left",
    headerStyleOverrides: { minWidth: "72px" }
  },
  "dsd-value": {
    id: "value",
    align: "center",
    isSeparated: true,
    headerStyleOverrides: { minWidth: "129px" }
  },
  "nosale-upc": {
    id: "upcLink",
    isSortable: true,
    sortBy: "upc",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: { minWidth: "98px" }
  },
  "products-upc": {
    id: "upcLink",
    isSortable: true,
    sortBy: "upc",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: { width: "7%" }
  },
  "dsd-upc": {
    id: "upcLink",
    isSortable: true,
    align: "right",
    sortBy: "upc",
    isSeparated: true,
    headerStyleOverrides: { minWidth: "98px" }
  },
  "nosale-onHand": {
    id: "onHand",
    isSortable: false,
    align: "right",
    headerStyleOverrides: { minWidth: "92px" }
  },
  "products-onHand": {
    id: "onHand",
    isSortable: true,
    align: "right",
    headerStyleOverrides: { width: "7%" }
  },
  "dsd-onHand": {
    id: "onHand",
    align: "right",
    headerStyleOverrides: { minWidth: "92px" },
    isSortable: true
  },
  "nosale-onOrder": {
    id: "onOrder",
    headerStyleOverrides: { minWidth: "129px" },
    isSortable: true,
    align: "right"
  },
  "products-onOrder": {
    id: "onOrder",
    headerStyleOverrides: { width: "7%" },
    isSortable: true,
    align: "right"
  },
  "dsd-onOrder": {
    headerStyleOverrides: { minWidth: "129px" },
    id: "onOrder",
    isSortable: true,
    align: "right"
  },
  "nosale-wos": {
    id: "wos",
    headerStyleOverrides: { minWidth: "129px" },
    isSortable: false,
    align: "right",
    isSeparated: true
  },
  "products-wos": {
    id: "productWos",
    headerStyleOverrides: { width: "7%" },
    isSortable: true,
    sortBy: "wos",
    align: "right",
    isSeparated: true
  },
  "dsd-wos": {
    isSortable: true,
    align: "right",
    isSeparated: true,
    id: "wos",
    headerStyleOverrides: { minWidth: "129px" }
  },
  "nosale-retail": {
    id: "retail",
    headerStyleOverrides: { minWidth: "129px" },
    align: "right"
  },
  "products-retail": {
    id: "retail",
    headerStyleOverrides: { width: "7%" },
    align: "right",
    isSortable: true
  },
  "dsd-retail": {
    id: "retail",
    align: "right",
    headerStyleOverrides: { minWidth: "129px" }
  },
  "nosale-salesUnit": {
    align: "right",
    headerStyleOverrides: { minWidth: "129px" },
    id: "salesUnit",
    isSortable: true
  },
  "products-salesUnit": {
    align: "right",
    headerStyleOverrides: { width: "9%" },
    id: "salesUnit",
    isSortable: true
  },
  "dsd-salesUnit": {
    id: "salesUnit",
    isSortable: true,
    headerStyleOverrides: { minWidth: "129px" },
    align: "right"
  },
  "nosale-salesRetail": {
    isSeparated: true,
    isSortable: true,
    headerStyleOverrides: { minWidth: "129px" },
    id: "salesRetail",
    align: "right"
  },
  "products-salesRetail": {
    isSeparated: true,
    isSortable: true,
    headerStyleOverrides: { width: "9%" },
    id: "salesRetail",
    align: "right"
  },
  "dsd-salesRetail": {
    id: "salesRetail",
    isSortable: true,
    align: "right",
    isSeparated: true,
    headerStyleOverrides: { minWidth: "129px" }
  },
  "nosale-avgRetail": {
    id: "avgRetail",
    align: "right",
    headerStyleOverrides: { minWidth: "129px" }
  },
  "products-avgRetail": {
    id: "avgRetail",
    align: "right",
    isSortable: true,
    headerStyleOverrides: { width: "6%" }
  },
  "dsd-avgRetail": {
    id: "avgRetail",
    align: "right",
    headerStyleOverrides: { minWidth: "129px" }
  },
  "nosale-margins": {
    id: "margins",
    sortBy: "margin",
    isSortable: true,
    align: "right",
    headerStyleOverrides: { minWidth: "129px" }
  },
  "products-margins": {
    id: "margins",
    sortBy: "margin",
    isSortable: true,
    align: "right",
    headerStyleOverrides: { width: "4%" }
  },
  "dsd-margins": {
    id: "margins",
    isSortable: true,
    align: "right",
    headerStyleOverrides: { minWidth: "129px" }
  },
  "transfer-docIdTransfer": {
    id: "docIdTransfer",
    isSeparated: true,
    dataCellStyleOverrides: { padding: "6px 16px" }
  },
  "transfer-date": getTransferActivityTableHeaderRules("date", "date"),
  "transfer-rf": getTransferActivityTableHeaderRules("rf", "rf"),
  "transfer-wh": getTransferActivityTableHeaderRules("wh", "wh"),
  "transfer-caseWT": getTransferActivityTableHeaderRules("caseWt", "caseWt"),
  "transfer-transfer": getTransferActivityTableHeaderRules(
    "transferTransfer",
    "transfer"
  ),
  "transfer-grocery": getTransferActivityTableHeaderRules(
    "transferGrocery",
    "grocery"
  ),
  "transfer-frozen": getTransferActivityTableHeaderRules(
    "transferFrozen",
    "frozen"
  ),
  "transfer-beerOrWine": getTransferActivityTableHeaderRules(
    "transferBeerOrWine",
    "beerOrWine"
  ),
  "transfer-deli2": getTransferActivityTableHeaderRules("deli2", "deli"),
  "transfer-generalMerchandise": getTransferActivityTableHeaderRules(
    "transferGeneralMerchandise",
    "nonFood"
  ),
  "transfer-healthOrBeauty": getTransferActivityTableHeaderRules(
    "transferHealthOrBeauty",
    "healthOrBeauty"
  ),
  "transfer-produce": getTransferActivityTableHeaderRules(
    "transferProduce",
    "produce"
  ),
  "transfer-meat2": {
    ...getTransferActivityTableHeaderRules("meat2", "meat"),
    isSeparated: true
  },
  "transfer-freight": getTransferActivityTableHeaderRules("freight", "freight"),
  "transfer-margins": getTransferActivityTableHeaderRules("margin", "margin"),
  "daily-date": {
    id: "date",
    isSortable: true,
    isSeparated: true,
    align: "center",
    dataCellStyleOverrides: { padding: "5.05px 15px" }
  },
  "daily-netSales": { id: "netSales", isSortable: true, align: "right" },
  "daily-deposits": { id: "deposits", isSortable: true, align: "right" },
  "daily-operatorVCA": { id: "operatorVCA", isSortable: true, align: "right" },
  "daily-coupons": {
    id: "coupons",
    align: "right",
    isSortable: true,
    isSeparated: true
  },
  "daily-grocery": { id: "grocery", align: "right", isSortable: true },
  "daily-frozen": { id: "frozen", align: "right", isSortable: true },
  "daily-gm": { id: "gm", align: "right", isSortable: true },
  "daily-hbc": { id: "hbc", align: "right", isSortable: true },
  "daily-deli": { id: "deli", align: "right", isSortable: true },
  "daily-b/w": { id: "bw", title: "b/w", align: "right", isSortable: true },
  "daily-produce": { id: "produce", align: "right", isSortable: true },
  "daily-meat": {
    id: "meat",
    align: "right",
    isSeparated: true,
    isSortable: true
  },
  "daily-salesTax": { id: "salesTax", align: "right", isSortable: true },
  "daily-customer": { id: "customer", align: "right", isSortable: true },
  "purchase-docId": {
    id: "priceChangesDocId",
    sortBy: "docId",
    isSortable: true,
    isSeparated: true,
    dataCellStyleOverrides: { padding: "6px 16px" }
  },
  "purchase-upc": { id: "upcLink", isSortable: true, sortBy: "upc" },
  "purchase-itemDesc": {
    id: "descriptionWithBadge",
    sortBy: "itemDesc",
    headerStyleOverrides: { minWidth: "250px" },
    dataCellStyleOverrides: { padding: "4px 16px" },
    isSortable: true
  },
  "purchase-pack": { id: "pack", align: "right" },
  "purchase-size": { id: "size", isSeparated: true, align: "right" },
  "purchase-dept": { id: "dept", align: "right", isSortable: true },
  "purchase-type": { id: "type", align: "right", isSortable: true },
  "purchase-reason": { id: "reason", align: "right", isSortable: true },
  "purchase-createdBy": { id: "createdBy", align: "right", isSortable: true },
  "purchase-effectiveDate": {
    id: "effectiveDate",
    item: "effective Date",
    isSeparated: true,
    align: "right",
    isSortable: true
  },
  "purchase-units": { id: "units", align: "right" },
  "purchase-oldRetail": { id: "oldRetail", align: "right" },
  "purchase-newRetail": { id: "newRetail", align: "right" },
  "purchase-exPriceChange": { id: "exPriceChange", align: "right" }
};

export const mapExport: { [key: string]: any } = {
  "price-itemName": {
    id: "itemWithoutLink",
    sortBy: "itemId",
    headerStyleOverrides: {
      width: "100px",
      px: "6px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      width: "100px",
      px: "6px",
      "& h6": { fontSize: "10px" }
    },
    isSortable: true
  },
  "price-item": {
    id: "item",
    dataCellStyleOverrides: {
      width: "130px",
      px: "6px",
      "& h6": { fontSize: "10px" },
      "& div": { fontSize: "10px" },
      whiteSpace: "initial"
    },
    isSortable: true,
    sortBy: "item",
    headerStyleOverrides: {
      px: "6px",
      "& div": { fontSize: "10px" }
    }
  },
  "price-pack": {
    headerStyleOverrides: {
      px: "6px",
      "& h6": { fontSize: "10px" }
    },
    id: "pack",
    align: "right",
    dataCellStyleOverrides: {
      px: "6px",
      "& h6": { fontSize: "10px" }
    }
  },
  "price-size": {
    id: "size",
    headerStyleOverrides: {
      px: "6px",
      "& h6": { fontSize: "10px", width: "30px" }
    },
    align: "left",
    dataCellStyleOverrides: {
      px: "6px",
      "& h6": { fontSize: "10px", width: "30px" }
    }
  },
  "price-upc": {
    id: "upcNonLink",
    isSeparated: true,
    isSortable: true,
    sortBy: "upc",
    align: "right",
    headerStyleOverrides: {
      px: "6px",
      whiteSpace: "initial",
      fontSize: "10px",
      "& h6": {
        fontSize: "10px",
        px: "0px",
        whiteSpace: "initial"
      }
    },
    dataCellStyleOverrides: {
      px: "6px",
      whiteSpace: "initial",
      "& h6": {
        fontSize: "10px",
        px: "0px",
        whiteSpace: "initial"
      }
    }
  },
  "price-posDescription": {
    isSeparated: true,
    sortBy: "posDescription",
    isSortable: true,
    id: "posDescription",
    align: "left",
    headerStyleOverrides: {
      px: "6px",
      width: "160px",
      "& h6": { fontSize: "10px", whiteSpace: "initial" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      width: "160px",
      "& h6": { fontSize: "10px", whiteSpace: "initial" }
    }
  },
  "price-storeRetail": {
    id: "storeRetail",
    isSortable: true,
    sortBy: "storeRetail",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      px: "8px",
      "& h6": { fontSize: "10px", whiteSpace: "initial" }
    },
    dataCellStyleOverrides: {
      px: "10px",
      "& h6": { fontSize: "10px", whiteSpace: "initial" }
    }
  },
  "price-goiRetail": {
    id: "goiRetail",
    isSortable: true,
    sortBy: "goiRetail",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      px: "8px",
      "& h6": { fontSize: "10px", whiteSpace: "initial" }
    },
    dataCellStyleOverrides: {
      px: "10px",
      "& h6": { fontSize: "10px", whiteSpace: "initial" }
    }
  },
  "price-exceptionType": {
    id: "exceptionType",
    isSortable: true,
    sortBy: "exceptionType",
    isSeparated: true,
    headerStyleOverrides: {
      px: "6px",
      "& h6": { fontSize: "10px", whiteSpace: "initial", width: "50px" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      "& h6": { fontSize: "10px", whiteSpace: "initial", width: "40px" }
    }
  },
  "price-lastSoldDate": {
    id: "lastSoldDate",
    isSortable: true,
    sortBy: "lastSoldDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      width: "10%",
      textAlign: "right",
      whiteSpace: "initial",
      "& h6": { fontSize: "10px" },
      px: "6px"
    },
    dataCellStyleOverrides: { px: "6px", "& h6": { fontSize: "10px" } }
  },
  "price-goiPriceChangeDate": {
    headerStyleOverrides: {
      width: "10%",
      textAlign: "right",
      whiteSpace: "initial",
      "& h6": { width: "100%", fontSize: "10px", justifyContent: "flex-end" },
      px: "6px"
    },
    id: "goiPriceChangeDate",
    align: "right",
    isSeparated: true,
    isSortable: true,
    sortBy: "goiPriceChangeDate",
    dataCellStyleOverrides: { px: "6px", "& h6": { fontSize: "10px" } }
  },
  "price-lastShippedRetail": {
    headerStyleOverrides: {
      width: "10%",
      textAlign: "right",
      whiteSpace: "initial",
      "& h6": { width: "100%", fontSize: "10px", justifyContent: "flex-end" },
      px: "6px"
    },
    id: "lastShippedRetail",
    align: "right",
    isSeparated: true,
    isSortable: true,
    sortBy: "lastShippedRetail",
    dataCellStyleOverrides: { px: "6px", "& h6": { fontSize: "10px" } }
  },
  "price-lastShippedDate": {
    id: "lastShippedDate",
    dataCellStyleOverrides: { px: "6px", "& h6": { fontSize: "10px" } },
    isSortable: true,
    headerStyleOverrides: {
      width: "10%",
      px: "6px",
      textAlign: "right",
      whiteSpace: "initial",
      "& h6": { fontSize: "10px" }
    },
    align: "right",
    isSeparated: true
  },
  "dept-itemName": {
    id: "itemWithoutLink",
    sortBy: "itemId",
    headerStyleOverrides: {
      px: "6px",
      fontSize: "10px",
      width: "90px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      fontSize: "10px",
      px: "6px",
      "& h6": { fontSize: "10px" }
    },
    isSortable: true
  },
  "dept-item": {
    sortBy: "item",
    id: "item",
    isSortable: true,
    headerStyleOverrides: {
      px: "6px",
      width: "125px",
      whiteSpace: "initial",
      fontSize: "10px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      width: "125px",
      px: "6px",
      fontSize: "10px",
      whiteSpace: "initial",
      "& div": { fontSize: "10px", whiteSpace: "initial" }
    }
  },
  "dept-pack": {
    id: "pack",
    align: "right",
    dataCellStyleOverrides: {
      width: "40px",
      px: "12px",
      "& h6": { fontSize: "10px" }
    },
    headerStyleOverrides: {
      fontSize: "10px",
      px: "6px",
      "& h6": { fontSize: "10px", width: "35px" }
    }
  },
  "dept-size": {
    id: "size",
    dataCellStyleOverrides: {
      width: "40px",
      px: "6px",
      fontSize: "10px",
      "& h6": { fontSize: "10px", width: "35px" }
    },
    align: "left",
    headerStyleOverrides: {
      px: "6px",
      fontSize: "10px",
      with: "40px",
      "& h6": { fontSize: "10px", width: "35px" }
    }
  },
  "dept-upc": {
    id: "upcNonLink",
    align: "right",
    headerStyleOverrides: {
      px: "6px",
      width: "80px",
      fontSize: "10px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      width: "80px",
      textAlign: "right",
      "& h6": {
        fontSize: "10px",
        px: "0",
        whiteSpace: "initial",
        width: "100%",
        textAlign: "right"
      }
    },
    isSortable: true,
    sortBy: "upc",
    fontSize: "10px",
    isSeparated: true
  },
  "dept-posDescription": {
    id: "posDescription",
    headerStyleOverrides: {
      px: "6px",
      width: "100px",
      whiteSpace: "initial",
      fontSize: "10px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      width: "100px",
      fontSize: "10px",
      whiteSpace: "initial",
      "& h6": { fontSize: "10px", whiteSpace: "initial", width: "80px" }
    },
    align: "left",
    sortBy: "posDescription",
    isSeparated: true,
    isSortable: true
  },
  "dept-goiDescription": {
    id: "goiDescription",
    align: "left",
    sortBy: "goiDescription",
    isSeparated: true,
    isSortable: true,
    headerStyleOverrides: {
      whiteSpace: "initial",
      width: "80px",
      fontSize: "10px",
      px: "6px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      whiteSpace: "initial",
      width: "80px",
      fontSize: "10px",
      px: "6px",
      "& h6": { fontSize: "10px", whiteSpace: "initial", width: "80px" }
    }
  },
  "dept-storeDept": {
    id: "storeDept",
    isSortable: true,
    sortBy: "storeDept",
    align: "left",
    isSeparated: true,
    headerStyleOverrides: {
      px: "6px",
      width: "90px",
      whiteSpace: "initial",
      fontSize: "10px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      fontSize: "10px",
      whiteSpace: "initial",
      width: "90px",
      fontWeight: "400",
      letterSpacing: "0.1px",
      color: theme.palette.grey[900]
    }
  },
  "dept-goiDept": {
    id: "goiDept",
    isSortable: true,
    sortBy: "goiDept",
    align: "left",
    isSeparated: true,
    headerStyleOverrides: {
      whiteSpace: "initial",
      px: "6px",
      width: "80px",
      fontSize: "10px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      fontSize: "10px",
      width: "80px",
      whiteSpace: "initial",
      "& h6": { fontSize: "10px" }
    }
  },
  "dept-lastSoldDate": {
    id: "lastSoldDate",
    isSeparated: true,
    headerStyleOverrides: {
      textAlign: "right",
      fontSize: "10px",
      whiteSpace: "initial",
      width: "70px",
      "& h6": { fontSize: "10px" },
      px: "6px"
    },
    align: "right",
    dataCellStyleOverrides: {
      fontSize: "10px",
      "& h6": { fontSize: "10px" },
      px: "6px"
    },
    isSortable: true,
    sortBy: "lastSoldDate"
  },
  "dept-storeDeptChangeDate": {
    id: "storeDeptChangeDate",
    isSortable: true,
    sortBy: "storeDeptChangeDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      textAlign: "right",
      whiteSpace: "initial",
      width: "70px",
      "& h6": { fontSize: "10px" },
      px: "6px",
      fontSize: "10px"
    },
    dataCellStyleOverrides: {
      fontSize: "10px",
      px: "6px",
      "& h6": { fontSize: "10px" }
    }
  },
  "dept-goiDeptChangeDate": {
    id: "goiDeptChangeDate",
    isSortable: true,
    sortBy: "goiDeptChangeDate",
    align: "right",
    isSeparated: true,
    headerStyleOverrides: {
      textAlign: "right",
      whiteSpace: "initial",
      width: "70px",
      "& h6": { fontSize: "10px" },
      px: "6px",
      fontSize: "10px"
    },
    dataCellStyleOverrides: {
      fontSize: "10px",
      px: "6px",
      "& h6": { fontSize: "10px" }
    }
  },
  "dept-username": {
    id: "username",
    align: "left",
    isSortable: true,
    sortBy: "userName",
    headerStyleOverrides: {
      px: "6px",
      width: "80px",
      whiteSpace: "initial",
      fontSize: "10px",
      "& h6": { fontSize: "10px" }
    },
    dataCellStyleOverrides: {
      px: "6px",
      fontSize: "10px",
      whiteSpace: "initial",
      "& h6": { fontSize: "10px" }
    }
  }
};

export const numberInputRestrictedValues = ["e", "E", "+", "-", "."];
export const defaultDateFormat = "MM/DD/YY";
export const talentDateFormat = "MM/DD/YYYY";
export const isoDateFormat = "YYYY-MM-DDTHH:mm:ss.sssZ";
export const mongoDBDateFormat = "YYYY-MM-DD";
export const fullDateTime = "MM/DD/YY HH:mm";
export const dotNetDateFormat = "DD-MM-YYYY";
export const monthDateFormat = "MM/DD";
export const dayofWeekFormate = "ddd";
export const DOLLAR = "$";

export const highlightedTypes: any = {
  asterisk: '<div class="asterisk-highlight">*</div>'
};

export const editableInvoiceTypes = [
  "Freight Claim",
  "Over/Short",
  "Yellow",
  "Transfer",
  "DSD",
  "Credit"
];

export const IAUserEditableStatus = ["pending", "approved"];

export const physicalInventoryEditableStatus = ["pending", "adjusted"];

export const mandatoryRejectionReasonInvoiceTypes = [
  "Freight Claim",
  "Over/Short",
  "Manual Transfer"
];

type TypeMapper = {
  [key: string]: string;
};
// name: API type mapper
export const genericTypeMapper: TypeMapper = {
  "Inventory Adjustment": "Pending Inventory Credits",
  "Pending Inventory Credits": "Inventory Adjustment"
};

export const yellowEditableDaysLimit = 14;

export const logisticsUserInvoiceTypes = ["Freight Claim", "Over/Short"];

export const inventoryAccountingUserInvoiceTypes = [
  "Inventory Adjustment",
  "Physical Inventory"
];

export const defaultEmptyValue = "-";

export const perpInvAvgReportId = "62e37b713bca0b5158228065";
export const PAGE_SIZE = 25;

export const overShortDateLimit = 30;
export const freightClaimDateLimit = 30;

export const approveStatusMap: { [key: string]: string[] } = {
  "over/short": ["pending"],
  "freight claim": ["pending"],
  "manual transfer": ["submitted"],
  "physical inventory": ["pending"],
  "inventory adjustment": ["pending"],
  default: ["none"]
};

export const reconcileStatusMap: { [key: string]: string[] } = {
  "physical inventory": ["approved"],
  default: ["none"]
};

export const rejectStatusMap: { [key: string]: string[] } = {
  "over/short": ["pending"],
  "freight claim": ["pending"],
  "manual transfer": ["submitted"],
  "physical inventory": ["pending"],
  "inventory adjustment": ["none"],
  default: ["none"]
};

export const approvePermissionMap: { [key: string]: string } = {
  "over/short": "approve-store-credit",
  "freight claim": "approve-store-credit",
  "manual transfer": "approve-manual-transfer",
  "physical inventory": "approve-physical-inventory",
  "inventory adjustment": "approve-pending-inventory",
  default: "none"
};

export const rejectPermissionMap: { [key: string]: string } = {
  "over/short": "reject-store-credit",
  "freight claim": "reject-store-credit",
  "manual transfer": "reject-manual-transfer",
  "physical inventory": "reject-physical-inventory",
  "inventory adjustment": "reject-pending-inventory",
  default: "none"
};

export const reconcilePermissionMap: { [key: string]: string } = {
  "physical inventory": "reconcile-physical-inventory",
  default: "none"
};

export const editPermissionMap: { [key: string]: string } = {
  "over/short": "edit-store-credit",
  "freight claim": "edit-store-credit",
  "manual transfer": PERMISSIONS.EDIT_MT,
  "physical inventory": "edit-physical-inventory",
  "inventory adjustment": "edit-pending-inventory",
  transfer: "edit-transfer",
  dsd: "edit-dsd",
  credit: "edit-credit",
  yellow: "create-yellow-adj",
  default: "none"
};

export const editRoleToStatusMap: {
  [key: string]: { [key: string]: string[] };
} = {
  "Logistics User": {
    "over/short": ["pending"],
    "freight claim": ["pending"]
  },
  "Independent Operator": {
    "over/short": ["pending", "approved"],
    "freight claim": ["pending", "approved"],
    "manual transfer": ["submitted"],
    "physical inventory": [],
    transfer: [],
    dsd: [],
    credit: [],
    yellow: ["pending"]
  },
  "Inventory Accounting User": {
    "physical inventory": ["pending", "approved"],
    "inventory adjustment": ["pending", "approved"],
    "pending inventory credits": ["pending", "approved"]
  },
  "Universal Operator": {
    "over/short": ["pending", "approved"],
    "freight claim": ["pending", "approved"],
    "manual transfer": ["submitted"],
    "physical inventory": [],
    transfer: [],
    dsd: [],
    credit: [],
    yellow: ["pending"]
  },
  Support: {}
};

type VendorType = {
  [key: number]: string;
};

export const vendorTypeMapper: VendorType = {
  2: "Warehouse",
  3: "DSD",
  4: "Both"
};

export const ITEM_TAGS_MAPPER: { [key: string]: string } = {
  CORE: "I"
};

export const transferDefaultInvoiceLabelPrefix = "Grocery Outlet WHSE";
export const sbtInvoiceLabel = "SBT";

export const approvedOrRejectedStatus = ["approved", "rejected"];

export const permissionsForLogisticsUser = [
  "approve-store-credit",
  "reject-store-credit",
  "edit-store-credit"
];

export const permissionsForInventoryAccountingUser = [
  "approve-pending-inventory",
  "edit-pending-inventory"
];

export const permissionsForIOUser = ["edit-store-credit"];

export const reportExportRowLimitPerFile = 10000;

export const MAX_RECEIVING_TYPES_FOR_EXPORT_LU_IAU = 2;

export const selectAllPalletItemColumnIds = [
  "over",
  "short",
  "damagedQuantity"
];

export const searchDebounceTime = 500;
export const RECEIVING_TYPES = {
  ManualTransfer: "Manual Transfer"
};
export const ARRAY_ELEMENTS = {
  FIRST_ELEMENT: 0,
  SECONS_ELEMENT: 1
};

export const ATTRIBUTES = {
  CASHIER: "cashier",
  REGISTER: "register",
  TENDER_TYPE: "tenderType",
  GIFT_CARD_ID: "hasGiftCard",
  REGISTER_NAME: "registerName",
  TRANSACTION_ID: "transactionId",
  TIME: "time",
  DATE: "date",
  REGISTER_NUMBER: "registerNumber",
  TOTAL_AMOUNT_MAX: "totalAmountMax",
  TOTAL_AMOUNT_MIN: "totalAmountMin",
  FROM: "from",
  TO: "to",
  TRANSACTION: "transaction",
  TOTAL_AMOUNT: "totalAmount",
  NEW_TLR_DISPLAY: "newTlrDisplay",
  TRANSACTION_TOTAL: "transactionTotal",
  LINE_ITEM_AMOUNT: "lineItemAmount",
  AMOUNT_BETWEEN: "amountBetween",
  STORE: "store",
  REGISTERS: "registers",
  CASHIERS: "cashiers",
  UPC: "upc",
  TENDER_TYPES: "tenderTypes",
  LINE_ITEM_TYPE: "lineItemType",
  CLEAR: "clear",
  DISPLAY: "display",
  UPC_LINK: "upcLink",
  EXPORT: "export",
  TRANSACTION_SEQ: "transactionSeq",
  UPC_OR_ITEMID: "upcOrItemId",
  REPORT: "report",
  ALERT: "alert",
  MANUAL_ADJUSTMENT: "Manual Adjustment",
  NAME: "name"
};

export const LIMITS = {
  DEFAULT_TABLE_ROWS: 25,
  DEFAULT_PAGE_INDEX: 1,
  TRANSACTION_LOG_REPORT_DATE_RANGE_LIMIT: 29,
  MAX_NUMERIC_INPUT_LENGTH: 16,
  DEFAULT_TOAST_NOTIFICATION_DURATION: 2000,
  GET_ALERT_INTERVAL_WHEN_NOTIFICATIONS_DISABLED: 1800000
};

export const DATE_FORMAT = {
  SHORT_DATE: "MM/DD/YY",
  LONG_DATE: "MM/DD/YYYY",
  DATABASE_DATE: "YYYY-MM-DD"
};

export const DATE_TIME_UNITS = {
  HOUR: "hour",
  MINUTE: "minute",
  DAYS: "days",
  DAY: "day",
  D: "d",
  H: "h",
  M: "m"
};

export const TIME_ZONE = {
  AMERICA_LOS_ANGELES: "America/Los_Angeles",
  UTC: "UTC"
};

export const SORT_ORDER = {
  DESC: "DESC",
  ASC: "ASC"
};
export const TRANSACTION_QUALIFIER: { [key: string]: string } = {
  NORMAL_SALES_ITEM: "5",
  TAX_INFO: "8",
  TENDER_INFO: "21",
  GIFT_COUPANS: "11"
};

export const PERMISSION = {
  VIEW_TRANSACTION_LOG_REPORT: "view-transaction-log-report",
  VIEW_TRANSACTION_LOG_REPORT_DETAIL_EXPORT:
    "view-transaction-log-report-detail-export",
  VIEW_TRANSACTION_LOG_REPORT_DETAIL: "view-transaction-log-report-detail"
};

export const SYMBOLS = {
  MINUS: "-",
  DOLLAR: "$"
};

export const itemTypeFlags = {
  parentChildItem: "PC",
  modComponentItem: "MC",
  singleItem: "S"
};

export const ITEM_RETAIL_TYPE_MAPPER: { [key: string]: string } = {
  "WAREHOUSE TRANSFER": "TRANSFER"
};

export const TYPES_TO_SHOW_MARGIN_FROM_ITEM_RETAIL_DATA = ["transfer", "dsd"];

export const ITEM_TAGS = {
  RANDOM_WEIGHT: "R"
};

export const WRR_DOC_TYPES_TO_SHOW_MARGIN = [
  "warehouse transfer",
  "dsd",
  "dsd credit",
  "order subtotal",
  "manual transfer"
];

export const TIME = {
  MILLISECONDS_PER_DAY: 1000 * 60 * 60 * 24,
  MILLISECONDS_PER_HOUR: 1000 * 60 * 60,
  MILLISECONDS_PER_MINUTE: 1000 * 60
};

export const ITEM_TYPES = {
  CORE: "I",
  CORE_ITEM: "CORE"
};

export const ITEM_TYPE_TAG_OPTIONS_MAPPER = {
  core: ["I", "CORE"]
};
